import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Checkbox from '@/shared/components/input/Checkbox';
import { useIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import messages from './filterMessages';

class ItemsFilter extends Component {
  state = {
    filterItems: [],
  };

  componentDidMount() {
    const { items, initialFilteredItems } = this.props;

    const initialFilteredValues =
      (initialFilteredItems && initialFilteredItems.map(item => item)) || [];

    const filterItems = items.map(item => {
      let key = item;
      if (typeof item === 'object' && item) {
        if (typeof item.key !== 'undefined') {
          // eslint-disable-next-line prefer-destructuring
          key = item.key;
        } else if (typeof item.id !== 'undefined') {
          key = item.id;
        }
      }

      return {
        checked: initialFilteredValues.includes(item),
        value: item,
        key,
      };
    });

    this.setState(state => ({
      ...state,
      filterItems,
    }));
  }

  handleClear() {
    this.setState(state => ({
      ...state,
      value: '',
    }));
  }

  onChange(item) {
    const { filterItems } = this.state;
    const { onFilter, hideFilterButton } = this.props;

    /* eslint-disable-next-line */
    item.checked = !item.checked;

    this.setState(
      state => ({
        ...state,
        filterItems,
      }),
      () => {
        // In multi-filter mode, notify parent of the change
        if (hideFilterButton) {
          const selectedItems = this.state.filterItems
            .filter(x => x.checked && x.value !== 'divider')
            .map(item => item.value);
          onFilter({ items: selectedItems });
        }
      }
    );
  }

  render() {
    const { filterItems } = this.state;
    const { onFilter, isFiltered, renderItem, intl, hideFilterButton } = this.props;

    const selectedItems = filterItems
      .filter(x => x.checked && x.value !== 'divider')
      .map(item => item.value);

    return (
      <div>
        {!hideFilterButton && (
          <>
            <button
              type="button"
              className="btn btn-inverse btn-block btn-sm margin10B"
              onClick={() => onFilter({ items: selectedItems })}
            >
              {intl.formatMessage(messages.Filter)}
            </button>

            {isFiltered && (
              <button
                type="button"
                className="btn btn-default btn-sm margin10B"
                onClick={() => onFilter({ items: [] })}
              >
                <i className="fa fa-times" />
                &nbsp;
                <span>{intl.formatMessage(messages.ClearFilter)}</span>
              </button>
            )}
          </>
        )}
        {filterItems.map(filterItem => (
          <div key={filterItem.key}>
            {filterItem.value === 'divider' ? (
              <hr style={{ margin: '0px' }} className="dark-line" />
            ) : (
              <label htmlFor={`checkbox-${filterItem.key}`}>
                <Checkbox
                  id={`checkbox-${filterItem.key}`}
                  value={filterItem.checked}
                  onClick={() => this.onChange(filterItem)}
                  text={renderItem ? renderItem(filterItem.value) : filterItem.value}
                />
              </label>
            )}
          </div>
        ))}
      </div>
    );
  }

  static propTypes = {
    items: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
      PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.bool, PropTypes.string])),
      PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        }),
      ),
    ]).isRequired,
    /** Array of values that should be checked when the items filter is shown */
    initialFilteredItems: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.number),
      PropTypes.arrayOf(PropTypes.bool),
      PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        }),
      ),
    ]),
    /** Function to execute when a value has been entered and search has been requested */
    onFilter: PropTypes.func.isRequired,
    /** Boolean indicating whether a value is currently being filtered. Used for displaying a clear filter button  */
    isFiltered: PropTypes.bool,
    renderItem: PropTypes.func,
    intl: intlShape.isRequired,
    /** Whether to hide the filter button and auto-apply on change */
    hideFilterButton: PropTypes.bool,
  };

  static defaultProps = {
    initialFilteredItems: undefined,
    renderItem: undefined,
    isFiltered: false,
    hideFilterButton: false,
  };
}

export default ItemsFilter;
